// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1064) return "static/chunks/1064.5a9ea84705bfd887.js";
	if (chunkId === 1139) return "static/chunks/1139.75ffc62dc9f865bc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"5557":"b39052bda961a371","7537":"dfec7171fa446f35","9756":"b7072e2133c434bf"}[chunkId] + ".js";
};